var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 65,
    viewBox: "0 0 57 65",
    width: 57,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 20.9008,
    x2: 33.8575,
    y1: 32.5001,
    y2: 32.5001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3dafe"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8ecfe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678d98"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 28.4999,
    x2: 28.4999,
    xlinkHref: "#b",
    y1: 26.6069,
    y2: -9.37289
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 28.4998,
    x2: 28.4998,
    xlinkHref: "#b",
    y1: 48.939,
    y2: 62.1248
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 17.1791,
    x2: 42.6601,
    y1: 34.0889,
    y2: 34.0889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee45a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea613"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fea613",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e94444"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 29.5829,
    x2: 29.5829,
    xlinkHref: "#f",
    y1: 27.6926,
    y2: -13.1089
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 28.4998,
    x2: 28.4998,
    xlinkHref: "#f",
    y1: 45.7856,
    y2: 61.8123
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fedbbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd3581"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 28.5,
    x2: 28.5,
    xlinkHref: "#i",
    y1: 0.680206,
    y2: 8.93929
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 28.5,
    x2: 28.5,
    xlinkHref: "#i",
    y1: 57.9068,
    y2: 66.1658
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.89 39.5922c-2.2146-3.0135-4.8969-5.4387-7.8292-7.0921 2.9321-1.6534 5.6146-4.0785 7.8292-7.092 2.5623-3.4865 4.5171-7.7936 5.6535-12.4555l1.9808-8.1235h-50.04871l1.97855 8.1231c1.54789 6.3465 4.48678 11.7963 8.49936 15.7608 1.5405 1.5228 3.2099 2.7922 4.9793 3.7872-1.7694.9951-3.4388 2.2643-4.9793 3.7871-4.01258 3.9646-6.9516 9.4143-8.49936 15.7609l-1.97855 8.1231h50.04861l-1.9809-8.1235c-1.1362-4.6619-3.0912-8.969-5.6533-12.4556z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m51.5435 52.0478c-1.1364-4.6619-3.0912-8.969-5.6535-12.4556-2.2146-3.0135-4.8969-5.4387-7.8292-7.0921 2.9321-1.6534 5.6146-4.0785 7.8292-7.092 2.5623-3.4865 4.5171-7.7936 5.6535-12.4555l1.9808-8.1235h-50.04871l.71041 2.91659 48.3427 48.34271z",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.45414 52.0482-1.97855 8.1231h50.04861l-1.9809-8.1235c-.9849-4.0406-2.5856-7.8136-4.6628-11.018h-36.7654c-2.07639 3.1935-3.66073 6.917-4.66096 11.0184z",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m34.7259 33.7953c-1.065-.5407-1.0647-2.0502.0003-2.5909 4.1179-2.0904 7.6807-6.2117 10.0978-11.7153.6217-1.4154.0456-3.0722-1.3077-3.8195l-4.9754-2.7479c-6.2493-3.45136-13.833-3.45161-20.0825-.0006l-4.9768 2.7482c-1.3661.7544-1.9221 2.4267-1.293 3.8549 1.3124 2.9795 2.9611 5.5528 4.8528 7.6167 1.5883 1.7336 3.3475 3.1068 5.2218 4.0593 1.0704.544 1.0704 2.0552 0 2.5991-1.8743.9526-3.6335 2.3258-5.2218 4.0593-3.2619 3.5589-5.8019 8.6305-7.14027 14.6902l-1.16822 5.2957h39.53389l-1.1695-5.2957c-1.9904-9.0167-6.6457-15.847-12.3714-18.7535z",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m34.7255 33.7956c-1.0649-.5406-1.0647-2.0502.0003-2.5908 4.1179-2.0905 7.6807-6.2117 10.0978-11.7152.6217-1.4154.0456-3.0722-1.3076-3.8196l-4.9753-2.7478c-6.2493-3.45137-13.8331-3.45163-20.0825-.0006l-4.9768 2.7482c-.2947.1627-.5491.3701-.7646.6067l33.7326 33.7325c-2.2493-7.7543-6.5491-13.5866-11.7239-16.2134z",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m47.0973 52.5493c-.98-4.4395-2.607-8.3474-4.6888-11.5195h-27.8193c-2.0817 3.1724-3.7076 7.0803-4.68807 11.5195l-1.16822 5.2957h39.53389z",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m52.3482 7.77324h-47.69645c-2.14652 0-3.886613-1.74009-3.886613-3.88662s1.740093-3.88662 3.886613-3.88662h47.69665c2.1465 0 3.8866 1.74009 3.8866 3.88662-.0001 2.14653-1.7402 3.88662-3.8868 3.88662z",
    fill: "url(#j)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m52.3482 64.9998h-47.69645c-2.14652 0-3.886613-1.7401-3.886613-3.8866s1.740093-3.8866 3.886613-3.8866h47.69665c2.1465 0 3.8866 1.7401 3.8866 3.8866-.0001 2.1465-1.7402 3.8866-3.8868 3.8866z",
    fill: "url(#k)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.d19c2ab4d31f716817dddd952a001402.svg";
export { ForwardRef as ReactComponent };